import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { calcRouteWithParameters } from "abweb/service/router/RouteEmitter";
export class BrowserRoute {
  /**
   * This class is immutable.
   * @param {string} routeTemplate  for example /view/foo/:reqParam
   * @param {URLPropMap} routeParams for example {"reqParam": 43}.
   * Note that optional params that have a value of undefined will be ignored
   * @param {URLPropMap} routeExtraParams what follows "?" for example {foo: "bar"}
   *                     Note: routeParams & routeExtraParams must be separate as have separate 'key' namespaces.
   * @param {string} preCalculatedRoute - only need to pass this in if the route can not be calculated
   *                 from the routeTemplate and routeParams (rare), or if the route has already been calculated
   *                 (saves this class from recalculating it)
   */
  constructor(routeTemplate, routeParams = {}, routeExtraParams = {}, preCalculatedRoute) {
    _defineProperty(this, "_route", void 0);
    /** @inheritDoc */
    _defineProperty(this, "routeTemplate", void 0);
    /** @inheritDoc */
    _defineProperty(this, "routeParams", void 0);
    /** @inheritDoc */
    _defineProperty(this, "routeExtraParams", void 0);
    this.routeTemplate = routeTemplate;
    // routeParams might be mobx-observable which can't be frozen, so make copy
    this.routeParams = {
      ...routeParams
    };
    Object.freeze(this.routeParams);
    // routeExtraParams might be mobx-observable which can't be frozen, so make copy
    this.routeExtraParams = {
      ...routeExtraParams
    };
    Object.freeze(this.routeExtraParams);
    this._route = preCalculatedRoute;
  }

  /**
   * @inheritDoc
   */
  get route() {
    if (this._route === undefined) {
      // Injects required/optional params if they exist in route, and adds any extra params if they exist
      this._route = calcRouteWithParameters(this.routeTemplate, this.routeParams, this.routeExtraParams);
    }
    return this._route;
  }
  toString() {
    return `BrowserRoute{route: '${this.route}', routeTemplate: '${this.routeTemplate}', ` + `routeParams: ${JSON.stringify(this.routeParams)}, extraParams: ${JSON.stringify(this.routeExtraParams)}}`;
  }
}
//# sourceMappingURL=BrowserRoute.js.map
